export const IMAGE_MIME = [
    'image/jpg',
    'image/jpeg',
    'image/png',
    'image/gif'
];
export const VIDEO_MIME = [
    'video/3gpp',
    'video/H264',
    'video/mp4',
    'video/mpeg',
    'video/MPV',
    'video/quicktime',
    'video/raw'
];
/**
 * Mime types accepted by DA, please add per usecase entry if you do need
 * some special case but I doubt you do.
 */ export const MIME_CONFIG = {
    forDeviationSubmit: [
        '*'
    ],
    forDeviationStashProtect: [
        ...IMAGE_MIME.filter((i)=>i !== 'image/gif')
    ],
    forDeviationAttachment: [
        '*'
    ],
    forEditorDropSubmit: [
        ...IMAGE_MIME
    ],
    forMediaManager: [
        ...IMAGE_MIME
    ],
    forFilePreview: [
        ...IMAGE_MIME
    ]
};
export const mimeTypeToPcpType = (mime)=>{
    if (mime === 'image/gif') {
        return 'gif';
    } else if (IMAGE_MIME.includes(mime)) {
        return mime.split('/').pop();
    } else if (VIDEO_MIME.includes(mime)) {
        return 'video';
    }
    return 'unknown';
};
export const mimeTypesToDropzoneAccept = (mimes)=>{
    return mimes ? Object.fromEntries(mimes.map((k)=>[
            k,
            []
        ])) : undefined;
};

//# sourceMappingURL=mime.js.map